<template>
  <div class="commenting">
    <div v-if="info.state" class="content-box">
      <div class="lesson-item">
        <div class="left">
          <div class="lesson-name-time" style="color: #f48b16e8 ;">
            {{ info.gradeName }} {{ info.timeStart }}
          </div>
          <div class="lesson-time-teacher">
            <div class="lesson-times" style="color: #f48b16e8 ;">{{ info.timeDate }} {{ info.timeStart }}-{{ info.timeStop }} </div>
            <!-- <div class="lesson-teachername"> {{ info.teacher }} </div> -->
          </div>
        </div>
      </div>
      <div class="comment-box-warp">
        <div class="comment-component" @click="showPickerShow">
          <div class="title-name"> 评分模板 </div>
          <div class="title-name" style="color: #2980f7;" > {{ lessonName }} > </div>
        </div>
        <popup v-model="showPicker" @close="onClose" :style="{ height: '65%', width: '100%' }" position="bottom" round
          closeable>
          <div class="poup-title"> 选择评分模板 </div>
          <div class="poup-message" style="color: #2980f7;"> 切换模板后，已填好的评分将恢复默认 </div>
          <div class="poup-select-box">
            <div v-for="(item, index) in lessonList" :key="index" class="poup-select-item" @click="setTarnLesson(item)">
              <div> {{ item.name }} </div>
              <icon v-if="item.id === currentItem.id" name="success" style="width: 20px; height: 20px" color="#8e8ed4" />
            </div>
          </div>
          <div class="select-confirm" @click="selectConfirm">确定</div>
        </popup>
      </div>
      <div class="student-item">
        <div class="student-img">
          <img src="@assets/images/1.jpg" />
        </div>
        <div class="student-name"> {{ info.name }} <div class="arrive">到课</div>
        </div>
      </div>
      <div class="praise-satar-component" v-if="lessonItemList.length">
        <div v-for="(item, index) in lessonItemList" :key="index" class="praise-start-item"
          :class="{ borderBottomNone: index + 1 === lessonItemList.length }">
          <div class="praise-start-name"> {{ item.name }} </div>
          <div class="praise-start-target">
            <div v-for="(item_min, index_min) in 5" :key="index_min" class="start-icon"
              @click="openStart(index_min + 1, index)">
              <img v-if="index_min + 1 <= item.startsCount" src="@assets/images/stars1.png" />
              <img v-else src="@assets/images/stars2.png" />
            </div>
          </div>
        </div>
      </div>
      <textarea-box :title="'评价'" :placeholder="'请评价'" v-model="message" :maxlength="1000" />
      <div class="box">
        <div v-if="selectState === 0" class="select-box">
          <div class="select-btn" @click="selectState = 1">上传图片</div>
          <div class="select-btn" @click="selectState = 2">上传视频</div>
        </div>
        <div v-if="selectState === 1" class="img-box">
          <div class="title-text">
            <div class="text">
              <div @click="showSelect = true" ref="selectBtn">上传图片视频</div>
              <div class="select-btn-min-box" v-show="showSelect">
                <div @click="selectState = 1" :class="{ selectState: selectState === 1 }" class="select-btn-min">上传图片
                </div>
                <div @click="selectState = 2" :class="{ selectState: selectState === 2 }"
                  class="select-btn-min bottom-top-01rem">上传视频</div>
              </div>
            </div>
            <div class="count-splice"> {{ imageList.length }}/{{ counter }} </div>
          </div>
          <uploader v-model="imageList" preview-size="calc(33.33vw - 10.7px)" multiple :max-count="counter"
            accept="image/*" class="img-select" :before-delete="beforeDelete" :after-read="afterRead" />
        </div>
        <div v-if="selectState === 2" class="video-box">
          <div class="title-text">
            <div class="text">
              <div @click="showSelect = true" ref="selectBtn">上传视频</div>
              <div class="select-btn-min-box" v-show="showSelect">
                <div @click="selectState = 1" :class="{ selectState: selectState === 1 }" class="select-btn-min">上传图片
                </div>
                <div @click="selectState = 2" :class="{ selectState: selectState === 2 }"
                  class="select-btn-min bottom-top-01rem">上传视频</div>
              </div>
            </div>
            <div class="count-splice"> {{ videoList.length }}/{{ videoCounter }} </div>
          </div>
          <uploader v-model="videoList" :preview-size="['calc(100vw - 16px)', '4rem']" class="img-select"
            image-fit="scale-down" multiple :max-count="videoCounter" accept="video/*" :before-delete="beforeDelete"
            :after-read="afterRead" />
        </div>
      </div>
      <div class="sub-btn" @click="subComment"> 发送 </div>
    </div>
  </div>
</template>

<script>
import { leaveamessageinquire, commentLessonTime } from "@api/grade";
import { addZoo, getFlieType } from '@common'
import { UPLOAD_IMG } from '@api/uploader'

import { Popup, Icon, Uploader } from 'vant'
import TextareaBox from '@components/common/textBox/textareaBox/TextareaBox'

export default {
  name: 'CommentIng',
  components: {
    Popup,
    Uploader,
    Icon,
    TextareaBox
  },
  data() {
    return {
      info: {},
      message: '',
      form: {},
      showPicker: false,
      lessonList: [
        { name: '不使用模板', id: 0, list: [] }
      ],
      lessonName: '不使用模板',
      lessonId: 0,
      lessonItemList: [],
      currentItem: {
        name: '不使用模板',
        id: 0,
        list: []
      },

      images: [],
      src: "",
      content: '',
      imgid: 0,
      userinfo: null,
      realList: [],
      slider_image: [],
      cateArray: [],
      cid: 0,
      cateValue: "",
      studentArray: [],
      sid: 0,
      studentValue: "",

      typeCurrIndex: 0,
      selectState: 1,
      catchCount: 0, //图片请求失败次数
      showSelect: false,
      imageList: [],
      imageUrlList: [],
      videoList: [],
      videoUrlList: [],
      uploadAwait: false, //上传等待
      counter: 6,
      videoCounter: 1,
      once: false
    }
  },
  methods: {
    setData(obj) {
      let _this = this;
      for (let key in obj) {
        _this[key] = obj[key];
      }
    },
    subComment() {
      if (this.once) { //一次提交
        return null;
      }
      let form = Object.assign(this.form); //form
      let commentText = this.message;
      if (!commentText) {
        return this.$Message.success('请填写评论');
      } else if (!Object.keys(form).length) {
        return this.$Message.success('评论失败！');
      }
      form.contentname = commentText; //contentname

      form.tpname_id = this.lessonId; //tpname_id
      if (this.lessonItemList.length) {
        form.startype = this.lessonItemList.map(item => item.id + '.' + item.startsCount).join(); //startype
      } else {
        form.startype = '0';
      }

      let files = [];
      if (!this.selectState) {
        return this.$Message.success('请选择上传的文件');
      } else if (this.selectState === 1) {
        if (!this.imageList.length) {
          return this.$Message.success('至少选择一张图片');
        } else if (this.imageList.length !== this.imageUrlList.length) {
          return this.$Message.success('图片未上传!');
        } else {
          files = this.imageUrlList;
        }
      } else if (this.selectState === 2) {
        if (!this.imageList.length) {
          return this.$Message.success('请选择视频');
        } else if (this.videoList.length !== this.videoUrlList.length) {
          return this.$Message.success('视频未上传!');
        } else {
          files = this.videoUrlList;
        }
      }
      form.video_images = files.join();
      this.once = true;
      this.sendResquest(form);
    },
    sendResquest(form) { //send comment
      commentLessonTime(form).then(res => {
        if (res.status === 200) {
          this.$Message.success('评论成功');
          this.$router.go(-2);
        } else {
          this.$Message.success('评论失败');
          once = false;
        }
      }).catch(() => {
        this.$Message.success('评论失败');
        this.once = false;
      })
    },
    showPickerShow() {
      this.setData({
        showPicker: true,
        currentItem: {
          name: this.lessonName,
          id: this.lessonId,
          list: this.lessonItemList
        }
      });
    },
    onClose() {
      this.setData({ showPicker: false });
    },
    setTarnLesson(item) {
      this.setData({
        currentItem: item,
      })
    },
    selectConfirm() {
      this.setData({
        showPicker: false,
        lessonName: this.currentItem.name,
        lessonId: this.currentItem.id,
        lessonItemList: this.currentItem.list
      })
    },
    openStart(count, index) {
      let itemListStore = Object.assign(this.lessonItemList, []);
      itemListStore[index].startsCount = count;
      this.setData({
        lessonItemList: itemListStore
      })
    },
    getStudentInfo({ teacherId, lessonId, id }) {
      let data = {
        teacher_id: teacherId,
        lesson_id: lessonId,
        student_id: id,
      }
      leaveamessageinquire(data).then(res => {
        let result = res.data.information[0];
        let infoStore = {
          gradeName: result.lesson,
          name: result.name,
          teacher: result.staff_name,
          timeDate: `${new Date(Number(result.signintime + '000')).getFullYear()}-${addZoo(new Date(Number(result.signintime + '000')).getMonth() + 1)}-${addZoo(new Date(Number(result.signintime + '000')).getDate())}`,
          timeStart: result.start_time,
          timeStop: result.stop_time,
          state: true
        }
        let lessonListStore = Object.assign(this.lessonList, []);
        result.template.forEach(item => {
          lessonListStore.push({
            name: item.template,
            id: item.id,
            list: item.tem.map(item => { return { id: item.id, name: item.template, startsCount: 0 } })
          })
        })
        if (lessonListStore[1].list.length >= 2) {
          this.setData({
            currentItem: lessonListStore[1],
            lessonName: lessonListStore[1].name,
            lessonId: lessonListStore[1].id,
            lessonItemList: lessonListStore[1].list,
          })
        }
        this.setData({
          info: infoStore,
          lessonList: lessonListStore
        })
      })
    },
    afterRead(file, index) { //选择（图片/视频）
      if (!Array.isArray(file)) {
        file = [file];
      }
      for (let i = 0; i < file.length; i++) {
        let fileUrl = file[i].file;
        let formData = new FormData();
        formData.append('file', fileUrl);
        this.uploadFile(formData, fileUrl, index.index + i)
      }
    },
    beforeDelete(file, index) { //移除（图片/视频）
      let indexT = index.index;
      if (getFlieType(file.file.name) === 'video') {
        this.videoList.splice(0, this.videoList.length);
        if (this.videoUrlList.length > indexT) {
          this.videoUrlList = [];
        }
      } else if (getFlieType(file.file.name) === 'image') {
        this.imageList.splice(indexT, 1);
        if ((this.imageUrlList.length - this.catchCount) > indexT) {
          this.imageUrlList.splice(indexT, 1);
        }
      }
    },
    uploadFile(formData, file, index) { //上传文件
      if (getFlieType(file.name) === 'image') {
        this.imageList[index].url = 'https://cdn.jsdelivr.net/npm/@vant/assets/leaf.jpeg';
        this.imageList[index].status = 'uploading';
        this.imageList[index].message = '上传中...';
      } else if (getFlieType(file.name) === 'video') {
        this.videoList[index].url = 'https://cdn.jsdelivr.net/npm/@vant/assets/leaf.jpeg';
        this.videoList[index].status = 'uploading';
        this.videoList[index].message = '上传中...';
      }
      let timer = setInterval(() => {
        if (!this.uploadAwait) {
          clearInterval(timer);
          this.uploadAwait = true;
          UPLOAD_IMG(formData).then(res => {
            let result = res.data.url;
            if (getFlieType(file.name) === 'image') {
              this.imageUrlList.push(result);
              delete this.imageList[index].url;
              this.imageList[index].status = '';
              this.imageList[index].message = '';
            } else if (getFlieType(file.name) === 'video') {
              this.videoUrlList.push(result);
              delete this.videoList[index].url;
              this.videoList[index].status = '';
              this.videoList[index].message = '';
            }
          }).catch(err => {
            if (getFlieType(file.name) === 'image') {
              this.catchCount++;
              this.imageList[index].url = 'https://cdn.jsdelivr.net/npm/@vant/assets/tree.jpeg';
              this.imageList[index].status = 'failed';
              this.imageList[index].message = '上传失败';
            } else if (getFlieType(file.name) === 'video') {
              this.videoList[index].url = 'https://cdn.jsdelivr.net/npm/@vant/assets/tree.jpeg';
              this.videoList[index].status = 'failed';
              this.videoList[index].message = '上传失败';
            }
            this.$Message.success(err.msg);
          }).finally(() => {
            this.uploadAwait = false;
          })
        }
      }, 50);
    },
    onShowSelect(e) {
      if (e.target !== this.$refs.selectBtn) {
        this.showSelect = false;
      }
    },
    documentTrigger() {
      this.$el.addEventListener('click', (e) => {
        this.onShowSelect(e);
      });
    }
  },
  mounted() {
    this.documentTrigger();
    const params = this.$route.query;
    let form = {
      lesson_id: params.lessonId,
      teacher_id: params.teacherId,
      student_id: params.id,
    }
    this.setData({
      form
    })
    this.getStudentInfo(params);

  },
}
</script>

<style scoped>
.commenting {
  width: 100vw;
  height: 100vh;
  background-color: #fbfbfb;
  position: relative;
  overflow-y: scroll;
}

.commenting::-webkit-scrollbar {
  display: none;
}

.content-box {
  display: flex;
  flex-direction: column;
  padding-bottom: 80px;
}

.lesson-item {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgb(251 251 253);
  padding: 10px;
  background-color: white;
}

.left {
  font-size: 16px;
}

.lesson-name-time {
  font-size: 17px;
  font-weight: 550;
}

.lesson-times {
  padding: 7px 0;
}

.comment-box-warp {
  background-color: white;
  margin: 8px 0;
}

.comment-component {
  display: flex;
  padding: 10px;
  justify-content: space-between;
  font-size: 16px;
  background-color: white;
}

.poup-title {
  padding: 10px 15px;
}

.poup-message {
  padding: 10px;
  background-color: #eedcff;
  font-size: 14px;
  color: #6c6fc1;
  letter-spacing: 1px;
}

.poup-select-box {
  font-size: 17px;
}

.poup-select-item {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid #f9f5ff;
}

.select-confirm {
  position: absolute;
  left: 20vw;
  bottom: 40px;
  width: 60vw;
  height: 35px;
  border-radius: 5px;
  background-color: #2980f7;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.student-item {
  padding: 15px;
  display: flex;
  border-bottom: 1px solid #f9f9f9;
  border-top: 1px solid #f9f9f9;
  align-items: center;
  background-color: white;
  margin-bottom: 8px;
}

.student-img {
  width: 60px;
  height: 60px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 15px;
}

.student-img img {
  width: 100%;
  height: 100%;
}

.student-name {
  display: flex;
  flex: 1;
  align-items: center;
}

.arrive {
  font-size: 13px;
  display: flex;
  align-items: center;
  margin-left: 10px;
  border: 1px solid #f48b16e8;
  color: #f48b16e8;
  height: 18px;
  padding: 0 5px;
  border-radius: 2px;
}

.praise-satar-component {
  background-color: white;
  margin-bottom: 10px;
  font-size: 15px;
}

.praise-start-item {
  padding: 10px;
  border-bottom: 1px solid #faf5fb;
  display: flex;
  justify-content: space-between;
}

.praise-start-target {
  display: flex;
}

.start-icon {
  margin: 0 2px;
}

.start-icon img {
  width: 25px;
  height: 25px;
}

.borderBottomNone {
  border-bottom: none;
}

.updata-box-warp {
  background: none;
  padding: 0;
  background-color: white;
}

.solids {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(33.33% - 10px);
  height: calc(33.33vw - 10px);
  position: relative;
  margin: 5px;
}

.updata-files {
  height: auto;
  display: flex;
  flex-wrap: wrap;

}

.icon-delet {
  position: absolute;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.4);
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-img {
  width: calc(33.33% - 10px);
  height: calc(33.33vw - 10px);
  position: relative;
  margin: 5px;
}

.bg-img img {
  width: 100%;
  height: 100%;
}

.box {
  padding-top: 0.2rem;
  width: 100%;
}

.img-select {
  padding-left: 8px;
}

.title-text {
  display: flex;
  padding: 0 0.2rem 0.2rem;
  justify-content: space-between;
}

.text {
  color: #848a90;
  position: relative;
  width: 2rem;
  text-align: center;
}

.select-btn-min-box {
  position: absolute;
  z-index: 200;
  background-color: white;
  width: 100%;
  text-align: center;
  border-radius: 0.1rem;
  overflow: hidden;
}

.select-btn-min {
  padding-top: 0.1rem;
}

.selectState {
  background: #b3cbf5;
  color: white;
}

.bottom-top-01rem {
  padding-bottom: 0.1rem;
}

.count-splice {
  color: #f48b16e8;
  margin-right: 24px;
}

.select-box {
  padding: 0 0.2rem;
}

.select-btn {
  width: 60%;
  margin: 0 20%;
  text-align: center;
  height: 0.6rem;
  line-height: 0.6rem;
  background-color: #99badc;
  color: white;
  border-radius: 0.2rem;
  margin-top: 0.2rem;
}

.sub-btn {
  width: 40vw;
  position: fixed;
  bottom: 61px;
  left: 30vw;
  background-color: #2980f7;
  color: white;
  padding: 5px;
  text-align: center;
  border-radius: 5px;
}</style>